import React from "react"
import { ColorPickerSeeker } from "@ui-seeker/core"

import { useUserSettingsAcriss, useUserSettingsAcrissValidator } from "../../../@hooks"
import { userSettingAcrissFormData } from "../../../@signals"


export default function UserSettingAcrissDrawerColor() {
	const { handleChangeAcrissFormData } = useUserSettingsAcriss()
	const { colorError } = useUserSettingsAcrissValidator()

    return <ColorPickerSeeker
		value={userSettingAcrissFormData.value?.color}
		onChange={newColor => handleChangeAcrissFormData(newColor, 'color')}
		label="Color"
		error={colorError}
	/>
}